import React, { useEffect, useRef, useState } from 'react'
import PersonalLandingMobilePreviewIframe from './PersonalLandingMobilePreviewIframe'

/** PC 미리보기 기준 논리 너비(일반 데스크톱 레이아웃 폭에 가깝게) */
export const PREVIEW_BASE_WIDTH_PC = 1280
/** 모바일 프레임 최대 논리 너비 — iframe max-width와 맞춤 */
export const PREVIEW_BASE_WIDTH_MOBILE = 390

/**
 * PC: 고정 논리 너비로 렌더한 뒤 패널 너비에 맞춰 등비 축소(scale).
 * 모바일: iframe 전용 문서에 포털 → 미디어쿼리가 iframe 폭(모바일 웹과 동일)을 따름.
 */
export default function PersonalLandingPreviewViewport({ mode = 'pc', children }) {
  if (mode === 'mobile') {
    return (
      <div className="w-full">
        <PersonalLandingMobilePreviewIframe>{children}</PersonalLandingMobilePreviewIframe>
      </div>
    )
  }
  return <PcPreviewScale>{children}</PcPreviewScale>
}

function PcPreviewScale({ children }) {
  const outerRef = useRef(null)
  const innerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [innerHeight, setInnerHeight] = useState(600)

  const baseWidth = PREVIEW_BASE_WIDTH_PC
  const scale = containerWidth > 0 ? Math.min(1, containerWidth / baseWidth) : 1
  const visualLeft = containerWidth > 0 ? Math.max(0, (containerWidth - baseWidth * scale) / 2) : 0

  useEffect(() => {
    const el = outerRef.current
    if (!el || typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width ?? 0
      setContainerWidth(w)
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  useEffect(() => {
    const inner = innerRef.current
    if (!inner || typeof ResizeObserver === 'undefined') return undefined
    const measure = () => {
      setInnerHeight(inner.scrollHeight || 600)
    }
    measure()
    const ro = new ResizeObserver(measure)
    ro.observe(inner)
    return () => ro.disconnect()
  }, [children, scale])

  const clipHeight = Math.max(240, innerHeight * scale)

  return (
    <div ref={outerRef} className="w-full">
      <div
        className="relative w-full overflow-hidden rounded-xl bg-white"
        style={{ height: clipHeight }}
      >
        <div
          ref={innerRef}
          className="absolute top-0 bg-white"
          style={{
            left: visualLeft,
            width: baseWidth,
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
